// *************************************************************************
// Append file field to form
// *************************************************************************

document.addEventSelectorListener("click", "[data-demand-attachment]", function(event, target) {
	event.preventDefault();

	let container = target.closest(".form-group").querySelector(".demand-attachments");
	let id = target.getAttribute("data-demand-attachment") + (container.children.length + 1);

	let element = document.createElement("input");
	element.multiple = true;
	element.id = id;
	element.classList.add("form-control", "mb-2");
	element.type = "file";
	element.name = "demand[attachments][]";
	container.appendChild(element);
});
